import { PatientPresence } from '@dreryk/egabinet-appointment-frontend-api';

import { visitPaths } from '~libs.desktop.shared.paths';

import { PatientPresenceFilterParam } from './PatientPresenceField.types';

export const FILTER_SEPARATOR = ',';
export const PATIENT_PRESENCE_ID_MAP: Record<PatientPresence, number> = {
   PRESENT: 0,
   UNKNOWN: 1,
};

export const getPatientPresenceFilterCount = (): number => {
   return Object.keys(PATIENT_PRESENCE_ID_MAP).length;
};

export const getPatientPresenceFilterSearchParamValue = (
   patientPresences: PatientPresence[]
): PatientPresenceFilterParam => {
   return patientPresences.map((status) => PATIENT_PRESENCE_ID_MAP[status]).join(FILTER_SEPARATOR);
};

export const getPatientPresenceFromSearchParam = (searchParamValue: number): PatientPresence | null => {
   const foundEntry = Object.entries(PATIENT_PRESENCE_ID_MAP).find(([, entrySearchParamValue]) => {
      return searchParamValue === entrySearchParamValue;
   });
   return foundEntry ? (foundEntry[0] as PatientPresence) : null;
};

export const mapPatientPresenceFilterParamToPatientPresence = (
   patientPresenceSearchParam: string | null
): PatientPresence[] => {
   if (!patientPresenceSearchParam) {
      return [];
   }

   const selectedPatientPresence = patientPresenceSearchParam.split(FILTER_SEPARATOR).reduce((acc, str) => {
      const num = Number(str);
      if (!Number.isNaN(num)) {
         acc.add(num);
      }

      return acc;
   }, new Set());

   if (!selectedPatientPresence.size) {
      return [];
   }

   return Object.entries(PATIENT_PRESENCE_ID_MAP).reduce<PatientPresence[]>((acc, [patientPresence, id]) => {
      if (selectedPatientPresence.has(id)) {
         acc.push(patientPresence as PatientPresence);
      }

      return acc;
   }, []);
};

export const isPatientPresenceFilterActive = (): boolean => {
   const searchParams = new URLSearchParams(location.search);
   return Boolean(searchParams.get(visitPaths.PATIENT_PRESENCE_SEARCH_PARAM));
};
